export default __webpack_public_path__ + "static/media/404.c5090da0.png";